module.exports = __webpack_public_path__ + "static/media/banner-2.988f0aa2.jpeg";